import styled, {css} from "styled-components";

export const VoucherCardBox = styled.div<{showCursor: boolean; }>`
    position: relative;

    width: 31rem;
    height: 18rem;
    margin: 0 auto 3rem;
    ${props => props.showCursor ? css`cursor: pointer` : ''};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 26rem;
        height: 15rem;
    }

    @media ${({theme}) => theme.mediaQuery.xlExact} {
        width: 33rem;
    }   

    @media ${({theme}) => theme.mediaQuery.xxl + " and " +  theme.mediaQuery.lowHeight} {
        width: 33rem;
    }   
`;
